/**
 * <ShopGestureCardSkeleton> — la forme d'une carte de geste pendant le chargement.
 *
 * La vraie carte, l'image, le nom et sa phrase, le prix et le bouton : la géométrie est celle de
 * `<ShopGestureCard>` et du bouton-poussoir, importée et non recopiée.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { pushButtonBoxHeight } from "../../atoms/Buttons/Button/Button"
import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { Card } from "../../molecules/Card"
import { GAME_GLYPH_SIZE } from "../../molecules/GameGlyph"
import { GESTURE_IMAGE_SIZE } from "./ShopGestureCard"

export function ShopGestureCardSkeleton() {
    return (
        <Card p="4">
            <Stack gap="3">
                <Row gap="3" align="start">
                    <Skeleton shape="block" width={GESTURE_IMAGE_SIZE} height={GESTURE_IMAGE_SIZE} />
                    <Stack gap="1" style={styles.body}>
                        <Skeleton textSize="text-lg" width={150} />
                        <Skeleton textSize="text-md" width="90%" />
                    </Stack>
                </Row>
                <Row gap="3" justify="between">
                    <Row gap="2">
                        <Skeleton shape="circle" size={GAME_GLYPH_SIZE.row} />
                        <Skeleton textSize="text-lg" width={92} />
                    </Row>
                    <Skeleton shape="block" width={110} height={pushButtonBoxHeight()} />
                </Row>
            </Stack>
        </Card>
    )
}

const styles = StyleSheet.create(() => ({
    body: { flex: 1, flexShrink: 1, minWidth: 0 },
}))
